<template>
    <div class="okraina-retail-home">

        <!--информация о выбранном магазине-->
        <okraina-retail-selected />

        <!--Оформить заявку-->
        <div class="btn btn3 btn-block btn-request" @click="onRequestClick">Заявка на самовывоз</div>

        <!--разделы каталога-->
        <okraina-catalog-sections-tabs :items="catalogSections" :title="'Каталог'" :pathToAll="'/catalog/'"
            :textToAll="'Больше'" />

        <!--товары со скидкой-->
        <okraina-slider-products :items="saleProducts" :title="'Лучшие скидки'" :pathToAll="'/catalog/discount/'"
            :textToAll="'Больше'" v-if="saleProducts.length > 0" />

        <!--хиты продаж-->
        <okraina-slider-products :items="hitProducts" :title="'Хиты продаж'" :pathToAll="'/catalog/saleleader/'"
            :textToAll="'Больше'" v-if="hitProducts.length > 0" />

        <!--Новинки-->
        <okraina-slider-products :items="newProducts" :title="'Новинки'" :pathToAll="'/catalog/newproduct/'"
            :textToAll="'Больше'" v-if="newProducts.length > 0" />
    </div>
</template>

<script>
import okrainaRetailSelected from "@/components/retail/selected.vue";
import okrainaCatalogSectionsTabs from "@/components/catalog/sections.tabs.vue";
import okrainaSliderProducts from "@/components/sliders/products.vue";

import rest from "@/plugins/rest";
import bus from "@/plugins/bus";
import tools from "@/plugins/tools";

import { mapGetters } from "vuex";

export default {
    name: "okraina-retail-home",
    components: {
        okrainaRetailSelected,
        okrainaCatalogSectionsTabs,
        okrainaSliderProducts
    },
    data() {
        return {
            loading: false,

            saleProducts: [],
            hitProducts: [],
            newProducts: [],

        };
    },

    props: {
        catalogSections: {
            type: Array,
            default() {
                return [];
            }
        },
        refreshIndex: {
            type: Number,
            default() {
                return 0;
            },
        },
    },

    computed: {

        ...mapGetters({
            retailShopId: "retail/getShopId"
        }),

        requests() {

            return {

                saleProducts: {
                    CLASS: "catalog",
                    METHOD: "products.getlist",
                    PARAMS: {
                        FILTER: {
                            //PROPERTY_AVAILABILITY_IN_SHOPS: this.retailShopId,
                            PROPERTY_ACTION_IN_SHOPS: this.retailShopId,
                        },
                        ORDER: {
                            rand: "asc",
                        },
                        NAV_PARAMS: {
                            NUM_PAGE: 1,
                            PAGE_SIZE: 8,
                            PAGES_COUNT: 1,
                        },
                        RESIZE_OPTIONS: tools.getProductListResizeOptions(),
                        SHOP_ID: this.retailShopId,
                    },
                },
                hitProducts: {
                    CLASS: "catalog",
                    METHOD: "products.getlist",
                    PARAMS: {
                        FILTER: {
                            //PROPERTY_AVAILABILITY_IN_SHOPS: this.retailShopId,
                            "!PROPERTY_SALELEADER": false,
                        },
                        ORDER: {
                            rand: "asc",
                        },
                        NAV_PARAMS: {
                            NUM_PAGE: 1,
                            PAGE_SIZE: 8,
                            PAGES_COUNT: 1,
                        },
                        RESIZE_OPTIONS: tools.getProductListResizeOptions(),
                        SHOP_ID: this.retailShopId,
                    },
                },
                newProducts: {
                    CLASS: "catalog",
                    METHOD: "products.getlist",
                    PARAMS: {
                        FILTER: {
                            //PROPERTY_AVAILABILITY_IN_SHOPS: this.retailShopId,
                            "!PROPERTY_NEWPRODUCT": false,
                        },
                        ORDER: {
                            rand: "asc",
                        },
                        NAV_PARAMS: {
                            NUM_PAGE: 1,
                            PAGE_SIZE: 8,
                            PAGES_COUNT: 1,
                        },
                        RESIZE_OPTIONS: tools.getProductListResizeOptions(),
                        SHOP_ID: this.retailShopId,
                    },
                }
            };
        },
    },

    watch: {
        refreshIndex: function () {
            this.loadData();
        }
    },

    methods: {

        /**
         * Загрузка данных
         */
        loadData(resolve = false) {

            //запрашиваем данные
            rest
                .batch(this.requests)
                .then((results) => {
                    this.onSuccessLoad(results);
                })
                .finally(() => {
                    this.loading = false;
                    if (resolve) {
                        resolve();
                    }
                });
        },

        /**
         * Обработка загрузки данных
         */
        onSuccessLoad(results) {
            for (var key in results) {
                let data = results[key];
                if (data.SUCCESS) {
                    //товары по скидке
                    if (key == "saleProducts") {
                        this.saleProducts = data.ITEMS;
                    }
                    //товары хиты
                    else if (key == "hitProducts") {
                        this.hitProducts = data.ITEMS;
                    }
                    //товары новинки
                    else if (key == "newProducts") {
                        this.newProducts = data.ITEMS;
                    }

                } else {
                    //показываем сообщение об ошибке
                    bus.emit("OKRAINA_MESSAGE_E_SHOW", { message: data.ERROR_TEXT });
                    return;
                }
            }
        },

        /**
         * Клик по кнопке "ЗАявка на самовывоз"
         */
        onRequestClick() {
            this.$router.push({ name: "shopping-list" })
        }

    },

    created() {
        this.loading = true;
        this.loadData();
    },
}

</script>

<style lang="scss">
.okraina-retail-home {
    .btn-request {
        margin-bottom: 10px;
    }
}
</style>